import { render } from "./MyBookings.vue?vue&type=template&id=cfe84ab8&scoped=true"
import script from "./MyBookings.vue?vue&type=script&lang=js"
export * from "./MyBookings.vue?vue&type=script&lang=js"

import "./MyBookings.vue?vue&type=style&index=0&id=cfe84ab8&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe84ab8"]])

export default __exports__